import React__default from 'react';
import { iconsByType } from './types.js';

function BrandImage(_a) {
    var type = _a.type, width = _a.width, height = _a.height, id = _a.id;
    var Icon = iconsByType[type];
    return Icon ? React__default.createElement(Icon, { width: width, height: height, id: id }) : null;
}

export { BrandImage as default };
